import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const TechnicalVisitIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M12,12a3.93,3.93,0,0,1-2.89-1.2,4,4,0,0,1-1.2-2.9A4,4,0,0,1,9.11,5,3.93,3.93,0,0,1,12,3.8,3.93,3.93,0,0,1,14.89,5a4,4,0,0,1,1.2,2.9,4,4,0,0,1-1.2,2.9A3.93,3.93,0,0,1,12,12ZM3.81,20.2V17.33a3.08,3.08,0,0,1,1.64-2.72,16.08,16.08,0,0,1,3.22-1.19,14.41,14.41,0,0,1,6.66,0,16.08,16.08,0,0,1,3.22,1.19,3.08,3.08,0,0,1,1.64,2.72V20.2Zm2.05-2.05H18.14v-.82a1,1,0,0,0-.14-.51,1.06,1.06,0,0,0-.37-.36,13.32,13.32,0,0,0-2.79-1,12,12,0,0,0-5.68,0,13.32,13.32,0,0,0-2.79,1,1.06,1.06,0,0,0-.37.36,1,1,0,0,0-.14.51ZM12,10a2,2,0,0,0,2.05-2,2,2,0,0,0-.6-1.45,2.05,2.05,0,0,0-2.9,0,2.05,2.05,0,0,0,0,2.9A2,2,0,0,0,12,10Z" />
    </SvgIcon>
  )
}
export default TechnicalVisitIcon
